<style>

.mdc-select {
   background: transparent;
   width: 100%;
   border: none;
   border-bottom: 1px solid #E1E1E1;
   line-height: 2em;
   border-radius: 0px;
   font-size: 16px;
  -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;
}
.mdc-select:focus { 
    /*background-color: yellow;*/
  outline: none;

   border-radius: 0px;
   border-bottom: 2px solid #2196F3;
   -webkit-box-shadow: none;
  -moz-box-shadow: none;
  
  box-shadow: none;
}
.mdc-select select > option {
  background-color: white;
}

</style>
<style scoped>
.md-input-container {
  padding-top: 0px !important;
  min-height: 0px !important;
}
</style>


<template>
  <div>
    <p class="md-body-2" v-html="question.q.en"></p>

    <div v-if="question.a" style="display: flex; justify-content: space-between; align-items: center">

      <div v-if="question.a.type == 'check'" style="flex-grow: 2">
        <md-checkbox :name="question.id" v-model="v" class="md-primary">{{question.a.value.en}}</md-checkbox>
      </div>

      <div v-if="question.a.type == 'boolean'">
        <md-radio class="md-primary" style="padding-right: 16px" :name="question.id" md-value="false" v-model="v">No</md-radio>
        <md-radio class="md-primary" style="padding-right: 16px" :name="question.id" md-value="true" v-model="v">Yes</md-radio>
      </div>

      <div v-if="question.a.type == 'number'" style="flex-grow: 2">
        <md-input-container>
          <md-input type="number" v-model="v" :placeholder="question.a.placeholder"></md-input>
        </md-input-container>
      </div>


      <div v-if="question.a.type == 'text'" style="flex-grow: 2">     
        <md-input-container>
          <md-input v-model="v" :placeholder="question.a.placeholder"></md-input>
        </md-input-container>
      </div>



      <div v-if="question.a.type == 'date'" style="flex-grow: 2">
        <date-picker :date="date" :option="datePickerOption" style="margin: 4px 0px 24px 0px"></date-picker>
      </div>

      <div v-if="question.a.type == 'array'" style="flex-grow: 2">

        <div v-if="question.a.max == 1 && question.a.display == 'radio'">
          <md-radio v-for="(item, i) in array" :key="i"
              class="md-primary" style="padding-right: 16px"
              :name="question.id" :md-value="i+1" v-model.number="vcheckbox">{{item.en}}</md-radio>
        </div>
        <div v-else-if="question.a.max == 1">
          <select class="mdc-select" v-model="v" size="1">
            <option></option>
            <option v-for="(item, i) in array" :value="i">{{item.en}}</option>
          </select>

            <!--<md-input-container>
              <label :for="question.id">{{question.placeholder}}</label>
              <md-select :name="question.id" v-model="v">
                <md-option v-for="(item, i) in array" :value="i">{{item.en}}</md-option>
              </md-select>
          </md-input-container>-->


        </div>
        <div v-else>
            
          <div v-for="(item, i) in array">
            <div class="md-checkbox md-primary" style="margin: 8px 0px"
                :class="{ 'md-checked': varray.indexOf(i) >= 0 }" >

              <div class="md-checkbox-container" @click="onClickCheck(i)" style="min-width: 20px">
                <input type="checkbox" :name="question.id">
                <div class="md-ink-ripple">
                  <div class="md-ripple" style="width: 20px; height: 20px;"></div>
                </div>
              </div> 
              <label :for="question.id" class="md-checkbox-label" style="height: auto">{{item.en}}</label>
        
            </div>
          </div>

        </div>
      </div>


      <div v-if="question.a.type == 'arraycomplete'">
        <input :list="question.id" type="search" v-model="v">
        <datalist :id="question.id">
          <option v-for="(item, i) in array" :value="item.en" :key="i"></option>
        </datalist>
      </div>

      <div v-if="question.info" style="margin-left: 16px" >
        <md-button class="md-icon-button" @click="viewInfo = !viewInfo">
          <md-icon style="width: 10px; color: #FF5722">help_outline</md-icon>
        </md-button>
        <!--<md-tooltip md-direction="top" class="md-body-1">{{question.info.en}}</md-tooltip>-->
      </div>
      
    </div>
    
    <transition name="fade">
      <div v-if="viewInfo && question.info" v-html="question.info.en" style="padding: 8px 16px 8px 0px"></div>
    </transition>

    <div v-if="hasError" style="color: red">{{err()}}</div>

  </div>
</template>

<script>
import moment from 'moment'
import Datepicker from './DatePicker'


export default {
  components: {
    'date-picker': Datepicker
  },

  props: {
    question: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errorMessage: {
      type: Object,
      required: false
    },
    value: {
      required: false
    }
  },

  watch: {
    question: function (newVal, oldVal) {
      this.updateQuestion(newVal)
    },

    value: function (newVal, oldVal) {
      this.updateValue(newVal)
    },


    v: function (newVal, oldVal) {
      if (!this.question.a) {
        this.$emit('answer-value', newVal)
        return
      }

      if (newVal !== oldVal && this.value !== newVal) {

        this.$nextTick(() => { this.$forceUpdate() })

        let v
        if (this.question.a.type === 'check') {
          v = newVal
        } else if (this.question.a.type === 'boolean') {
          v = newVal === 'true'
        } else if (this.question.a.type === 'number') {
          v = newVal
        } else if (this.question.a.type === 'text') {
          v = newVal
        } else if (this.question.a.type === 'date') {
          v = newVal
        } else if (this.question.a.type === 'array') {
          v = newVal
        } else if (this.question.a.type === 'arraycomplete') {
          for (let i = 0; i < this.array.length; i++) {
            if (this.array[i].en === newVal) {
              v = i
            }
          }
        }

        let hasError = !this.question.checkCondition(v, this.values)
        if (hasError) {
          this.$emit('answer-error', v)  
        }
        this.hasError = hasError

        if (v !== this.value) {
          this.$emit('answer-value', v)
        }
      }
    },

    varray: function (newVal, oldVal) {
      if (newVal !== this.value && newVal !== oldVal) {
        this.v = newVal
      }
    },

    'date.time': function (newVal, oldVal) {
      if (newVal !== this.value && newVal !== oldVal) {
        this.v = newVal
      }
    }
  },

  data: function () {
    return {
      displayArray: false,
      v: null,
      varray: [],
      
      
      date: {
        time: ''
      },
      datePickerOption: {
        type: 'day',
        week: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
        month: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'width': '100%',
          'padding': '0px',
          'line-height': '32px',
          'font-family': 'Roboto,Lato,sans-serif', 
          'font-size': '16px',
          'border': '0px solid',
          'border-radius': '0px',
          'border-bottom': '1px solid #e1e1e1'
        },
        color: {
          checked: '#F50057',
          header: '#2196F3',
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Annuler'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },

      viewInfo: false,

      hasError: false
    }
  },

  computed: {
    vcheckbox: {
      get: function () {
        if (this.v == null) {
          return null
        }
        return this.v + 1
      },
      set: function (newVal) {
        this.v = newVal - 1
      }
    },

    minDate: function () {
      if  (this.question.a.type === 'date') {
        return this.question.a.min
      }
      return null
    },
    maxDate: function () {
      if  (this.question.a.type === 'date') {
        if (this.question.a.max === 'today') {
          return moment().format('YYYY-MM-DD')
        } else {
          return this.question.a.max
        }
      }
      return null
    },

    array: {
      get: function () {
        if (this.displayArray) {
          return []
        } else {
          return this.question.array(this.values)
        }
      }
    }


  },

  created: function () {
    this.updateQuestion(this.question)
    if (this.value != null) {
      this.updateValue(this.value)
    }
  },
  mounted: function () {
  },
  updated: function () {
  },

  methods: {
    reset: function () {
      this.displayArray = true
      this.$nextTick(() => {
        this.displayArray = false
      })      
    },

    onClickCheck: function (val) {
      let index = this.varray.indexOf(val)
      if (index >= 0) {
        this.varray.splice(index, 1)
      } else {
        this.varray.push(val)
      }
      this.v = this.varray.slice(0)

    },
    isChecked: function (val) {
      return this.varray.indexOf(val) >= 0
    },

    onClickInfo: function (info) {
      global.navigationBarBus.$emit('info', info)
    },

    updateQuestion: function (val) {
      this.hasError = false
    },

    updateValue: function (newVal) {
      if (!this.question.a) {
        this.v = newVal
        return
      }
      
      if (newVal == null) {
        this.v = newVal
      } else {
        if (this.question.a.type === 'check') {
          this.v = newVal
        }

        if (this.question.a.type === 'boolean') {
          if (typeof newVal === 'boolean') {
            this.v = newVal ? 'true' : 'false'
          }
        }

        if (this.question.a.type === 'number') {
          if (typeof newVal === 'number') {
            this.v = newVal
          }
        }

        if (this.question.a.type === 'text') {
          this.v = newVal
        }

        if (this.question.a.type === 'date') {
          this.date.time = newVal
        }

        if (this.question.a.type === 'array') {
          if (this.question.a.max === 1) {
            this.v = newVal
          } else {
            this.varray = newVal
          }
        }

        if (this.question.a.type === 'arraycomplete') {
          let array = this.array 
          if (newVal in array) {
            this.v = array[newVal].en
          } 
        }
      }
    },

    err: function () {
      if (!this.question.a) {
        return
      }
      
      let msg = this.question.a['error-message']
      if (msg == null) {
        msg = this.errorMessage
      }
      
      if (msg != null) {
        return msg.en
      }
      

    }
  }
}

</script>



// WEBPACK FOOTER //
// Question.vue?5cf3b21e